import React from 'react';
import { IParticipant } from 'twain-sport-fe-mono/interfaces';

export const useParticipantsByCode = <T extends IParticipant>(participants: T[]) =>
    React.useMemo(
        () =>
            participants.reduce<Record<string, T>>((previous, current) => {
                previous[current.code] = current;
                return previous;
            }, {}),
        [participants],
    );
